<template>
    <section class="guide-section" :class="sectionPositionClass">
        <div class="inner-container">
            <v-mdi
            :name="iconName"
            :size="72"
            />
            <h2>{{title}}</h2>
            <p>
                {{description}}
                <img v-if="!!arrowConfig" class="arrow" :src="arrowImage" :style="arrowPosition" :class="{'arrow--reversed':arrowConfig.isPointingLeft}" />
            </p>
            <Button
                @click="$emit('knowMoreClicked')"
                label="En savoir +"
                :class="buttonClass"
            />
        </div>

    </section>

</template>
<script>
export default {
    name: "GuideSection",
    props: {
        sectionIndex: String,
        iconName: String,
        title: String,
        description: String,
        buttonClass: String,
        /** Accepts left, center or right */
        horizontalPosition: String,
        arrowConfig: Object,
        withTopPadding: Boolean,
    },
    data() {
        return {
            arrowBlack: require('@/assets/img/guide/arrow_black.png'),
            arrowBlue: require('@/assets/img/guide/arrow_blue.png'),
            arrowGreen: require('@/assets/img/guide/arrow_green.png'),
            arrowPurple: require('@/assets/img/guide/arrow_purple.png'),
            arrowRed: require('@/assets/img/guide/arrow_red.png'),
            arrowYellow: require('@/assets/img/guide/arrow_yellow.png'),
        }
    },
    computed: {
        sectionPositionClass() {
            const guideSectionPositionClass = `guide-section--${this.horizontalPosition}`
            return {
            [guideSectionPositionClass]: true,
            "guide-section--withTopPadding": this.withTopPadding,
            }
        },
        arrowImage() {
            switch(this.arrowConfig.color) {
                case "black":
                    return this.arrowBlack
                case "blue":
                    return this.arrowBlue
                case "green":
                    return this.arrowGreen
                case "purple":
                    return this.arrowPurple
                case "red":
                    return this.arrowRed
                case "yellow":
                    return this.arrowYellow
            }
        },
        arrowPosition() {
            return {
                top: `${this.arrowConfig.topPosition}vh`,
                left: `${this.arrowConfig.leftPosition}vw`,
            }
        }
    }
}
</script>